import styled from 'styled-components';
import { BaseDialog } from 'app/shared/modules/Dialog/styles';

export const Dialog = styled(BaseDialog)`
  width: calc(100% - 16px);
  left: 8px;
  top: 16px;
`;
